import { mapQuestionIndexToPercentage, MAX_QUESTION_INDEX } from "../shared/model/GameUtils"
import { useMemo } from "react";
import AnswerButtons from "./AnswerButtons";

export default function EditOrAddAnswerComponent({nextQuestionIndex, editQuestionIndex, disableJoker, onClick = () => {}}) {
  const gameCompleted = useMemo(() => 
    nextQuestionIndex > MAX_QUESTION_INDEX || nextQuestionIndex === -1
  , [nextQuestionIndex]);
  
  const nextEnabled = useMemo(() => 
    editQuestionIndex === -1 && !gameCompleted
  , [editQuestionIndex, gameCompleted]);

  const nextDisabled = useMemo(() => 
    editQuestionIndex === -1 && gameCompleted
  , [editQuestionIndex, gameCompleted]);

  return (<>
    {nextEnabled
    ? <>
        <div className="center">
          Nächste Frage 
          (<span className="marked primary">{mapQuestionIndexToPercentage(nextQuestionIndex)}%</span>)
          beantworten mit ...
        </div>
        <AnswerButtons onClick={onClick} disableJoker={disableJoker || nextQuestionIndex === MAX_QUESTION_INDEX} />
      </>
    : nextDisabled ?
      <>
        <div className="center">Spiel beendet.</div>
        <AnswerButtons disableAll={true} />
      </>
    : <>
        <div className="center">
          Antwort der&nbsp; 
          <span className="marked primary">{mapQuestionIndexToPercentage(editQuestionIndex)}%</span>-Frage
          ändern:
        </div>
        <AnswerButtons onClick={onClick} disableJoker={disableJoker || editQuestionIndex === MAX_QUESTION_INDEX} />
    </>}
  </>)
}
